<template>
  <div class="goods-list-combox">
    <el-table :data="pageData.items" border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column align="center" prop="id" label="ID" width="80" fixed="left" />
      <el-table-column align="center" prop="order_no" label="订单号" width="165" fixed="left" />
      <el-table-column header-align="center" label="商品信息" min-width="360">
        <template slot-scope="scope" v-if="scope.row.detail">
          <div class="goods-item" v-for="(item,index) in scope.row.detail" :key="index">
            <img style="width: 32px; height: 32px;" :src="item.goods_image" fit="cover" />
            <div style="height: 32px;line-height: 32px;margin-left: 5px;display: inline-block;">{{item.goods_title}} x {{item.quantity}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="receiver" label="收货人" width="100"/>
      <el-table-column align="center" prop="receiver_phone" label="手机号码" width="110"/>
      <el-table-column align="center" prop="receiver_address" label="地址" width="200"/>
      <el-table-column align="center" label="配送时间" width="140" fixed="right">
        <template slot-scope="scope">
          <span v-if="scope.row.extend">{{scope.row.extend.delivery.dateText}}（{{scope.row.extend.delivery.week}}）</span>
        </template>
      </el-table-column>
      <el-table-column header-align="center" prop="ctime" label="下单时间" width="160" />
      <el-table-column align="center" label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <span class="action" v-for="(action,index) in scope.row.actions" :key="'action-' +index" @click="processAction(action.remark, scope.row)">{{action['title']}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="pageData.totalPage">
      <el-pagination background layout="total, prev, pager, next" :current-page="pageData.page" :page-size="pageData.pageSize" :total="pageData.amount" @current-change="handlePageChange" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'MilkOrderListComponent',
  props: {
    pageData: {}
  },
  data () {
    return {
      formData: {},
      showEditDialog: false
    }
  },
  methods: {
    handleSelectionChange (val) {
      let ids = []
      for (let i in val) {
        ids.push(val[i]['id'])
      }
      this.$emit('onSelectChanged', ids)
    },
    handlePageChange (val) {
      this.$emit('onPageChanged', val)
    },
    processAction (action, data) {
      switch (action) {
        case 'VIEW':
          return this.$emit('view', data)
        case 'CLOSE':
          return this.$emit('close', data)
        case 'REMOVE':
          return this.$emit('remove', data)
        case 'EDIT':
          return this.$emit('edit', data)
        default:
          this.$message.error('未知的操作类型')
      }
    }
  }
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: center;
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}
.image-box{
  .image-item{
    display: inline-block;
  }
}
.goods-thumb {
  width: 130px;
  height: 130px;
  padding: 5px;
  border: solid 1px #ddd;
  margin: 5px;
}

.goods-item{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/order/MilkOrderListComponent.vue